import {__usuarios_endpoints} from "@components/usuario/endpoints/__usuarios_endpoints.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IGetUsuarioFilter} from "@components/usuario/dto/request/IGetUsuarioFilter.ts";

interface UsuarioPesquisaProps extends DefaultConsumerPesquisaAutoProps<IUsuario, IGetUsuarioFilter> {
}

export function UsuarioPesquisa(props: UsuarioPesquisaProps) {

    const handleItemSelected = (item?: IUsuario) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const formatUsuario = (usuario: IUsuario) => `${usuario.id} - ${usuario.nome ?? ''} - ${usuario.email}`;

    // Define how to render info if needed, otherwise omit renderInfoContent prop
    return (
        <DefaultPesquisaAuto<IUsuario, IGetUsuarioFilter>
            searchField={'nome'}
            endpoint={__usuarios_endpoints['v2']["get-usuarios"]}
            itemToString={formatUsuario}
            onItemSelected={handleItemSelected}
            {...props}
        />
    );
}

//interface ContaContabilPesquisaProps extends DefaultConsumerPesquisaAutoProps<IContaContabil, IContasContabeisFiltroDto> {
// }
//
// export function ContaContabilPesquisa(props: ContaContabilPesquisaProps) {
//     const handleItemSelected = (item: IContaContabil | undefined) => {
//         if (props.onItemSelected) {
//             props.onItemSelected(item);
//         }
//     };
//
//     const handleFormat = (conta: IContaContabil) => `${conta.nomeCompletoFormatado} ${conta.nome} - ${conta.id}`;
//
//     return (
//         <DefaultPesquisaAuto<IContaContabil, IContasContabeisFiltroDto>
//             endpoint={__contacontabil_endpoints['v2']["get-contas-contabeis"]} // Pass the API function
//             searchField={'search'}
//             itemToString={handleFormat}   // Pass the formatting function
//             onItemSelected={handleItemSelected} // Pass the selection handler
//             display={{
//                 name: "Produto"
//             }}
//             {...props}
//         />
//     );
// };